import { PersonLane } from '@app/modules/persons/appearances/types';
import { TimeRange } from '@mi-front/core';
import { Box } from '@mui/material';
import { STREAM_UI_CONFIG } from '../../../../../consts';
import { HoverLaneSetter } from '../../shared/apply-lane-hover';
import { PersonLaneRow } from './PersonLaneRow';

const MAX_HEIGHT = STREAM_UI_CONFIG.personsLanesMaxHeight;

type PersonsLanesViewportProps = {
  lanes: PersonLane[];
  range: TimeRange<number>;
  hoveredLaneKey: string | null;
  onHoverLane: HoverLaneSetter;
};

/**
 * Expanded Personas density: stacked swim lanes in a capped scroll viewport.
 *
 * Shows one {@link PersonLaneRow} per person in the focus window. Height is
 * capped so many people scroll inside the track instead of growing the page;
 * density collapse is handled by the header toggle, not here.
 */
export function PersonsLanesViewport({
  lanes,
  range,
  hoveredLaneKey,
  onHoverLane,
}: PersonsLanesViewportProps) {
  return (
    <Box data-testid="persons-track">
      <Box
        sx={{
          maxHeight: MAX_HEIGHT,
          overflowY: 'auto',
          scrollbarGutter: 'stable',
        }}
      >
        {lanes.map((lane) => (
          <Box key={lane.laneKey}>
            <PersonLaneRow
              lane={lane}
              range={range}
              dimmed={!!hoveredLaneKey && hoveredLaneKey !== lane.laneKey}
              emphasized={hoveredLaneKey === lane.laneKey}
              onHoverLane={onHoverLane}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
